import { styled } from "styled-components";
export const AboutusContainer = styled.div``;
export const AboutusWrapper = styled.div`
  padding: 60px 0;
  @media all and (max-width: 768px) {
    padding: 9.115vw 0;
  }
`;

export const AboutusWrap = styled.div`
  display: flex;
  gap: 64px;
  @media all and (max-width: 1024px) {
    gap: 42px;
  }

  @media all and (max-width: 768px) {
    flex-direction: column;
    gap: 3.125vw;
    align-items: center;
  }
`;

export const AboutusImgWrap = styled.div`
  max-width: 400px;
  > img {
    width: 100%;
  }
  @media all and (max-width: 900px) {
    max-width: 260px;
  }
  @media all and (max-width: 768px) {
    max-width: 39.063vw;
  }
`;
export const AboutusTextWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 64px;
  > img {
    width: 250px;
  }
  .text-wrap {
    display: flex;
    flex-direction: column;
    gap: 24px;
    text-align: left;
    > h6 {
      color: #233e99;
      font-size: 24px;
      line-height: 1.3;
      font-weight: bold;
    }
    > p {
      font-size: 20px;
      color: #242424;
      line-height: 1.4;
      .pc-br {
        display: block;
      }
    }
  }
  .bold-text-wrap {
    font-weight: bold;
    font-size: 20px;
    color: #242424;
    line-height: 1.4;
    text-align: left;
  }
  @media all and (max-width: 768px) {
    gap: 5.208vw;
    > img {
      width: 28.646vw;
      margin: 0 auto;
    }
    .text-wrap {
      gap: 1.823vw;
      text-align: center;
      > h6 {
        font-size: 4.167vw;
      }
      > p {
        font-size: 3.646vw;
        word-break: keep-all;
        .pc-br {
          display: none;
        }
      }
    }
    .bold-text-wrap {
      font-size: 3.906vw;
      text-align: center;
    }
  }
`;
